<template>
  <v-container fluid>
    <v-row v-show="!isBatch">
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-row>
            <v-col
              cols="5"
              class="pl-8 pb-0"
            >
              <v-autocomplete
                v-model="company"
                v-validate="'required'"
                :items="companies"
                :error-messages="errors.collect('company')"
                data-vv-name="company"     
                label="Company"
                item-text="name"
                item-value="id"
                return-object
                @change="resetSalaryMonth"
              />
            </v-col>
            <v-col
              cols="5"
              class="pl-2 pb-0"
            >
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="formatSalaryMonth"
                    v-validate="'required'"
                    :error-messages="errors.collect('formatSalaryMonth')"
                    data-vv-name="formatSalaryMonth"
                    data-vv-as="salary month"
                    label="Salary Month"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  ref="picker"
                  v-model="salaryMonth"
                  type="month"
                  scrollable
                  @click:month="menu = false"
                />
              </v-menu>
            </v-col>
            <v-col
              cols="2"
              class="ma-auto pl-2"
            >
              <v-btn
                v-if="salaryBatches.length < 1"
                color="primary"
                class="mr-2"
                @click="beforeGenerate()"
              >
                Create New Batch
              </v-btn>
            </v-col>

            <v-col cols="12">
              <div
                v-if="payrollClosing"
                style="border-radius:10px;background:aliceblue;width:98%;margin:auto"
                class="elevation-6 mb-3 pt-1"
              >
                <v-row
                  no-gutters
                  class="my-2"
                >
                  <v-col
                    cols="12"
                    class="text-center"
                  >
                    <span class="font-weight-bold font-18"><u>Month End Closing Summary</u></span>
                  </v-col>
                </v-row>
                
                <v-row class="mx-3">
                  <v-col
                    cols="4"
                    class="pt-0"
                  >
                    <v-row no-gutters>
                      <v-col cols="6">
                        <span class="font-weight-bold font-14">Total No of Employees:</span>
                      </v-col>
                      <v-col
                        cols="3"
                        class="text-right font-14"
                      >
                        <span>{{ payrollClosing.no_of_employees }}</span>
                      </v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col cols="6">
                        <span class="font-weight-bold font-14">Total Employee Net Pay (RM):</span>
                      </v-col>
                      <v-col
                        cols="3"
                        class="text-right font-14"
                      >
                        <span>{{ currencyFormatting(grandTotalNetSalary(payrollClosing.payroll_closing_details)) }}</span>
                      </v-col>
                    </v-row>
                  </v-col>
                  
                  <v-col
                    cols="8"
                    class="pt-0"
                  >
                    <v-row no-gutters> 
                      <v-col cols="3" />                    
                      <v-col
                        cols="3"
                        class="text-right"
                      >
                        <span class="font-weight-bold font-14">Employer (RM)</span>
                      </v-col>
                      <v-col
                        cols="3"
                        class="text-right"
                      >
                        <span class="font-weight-bold font-14">Employee (RM)</span>
                      </v-col>
                      <v-col
                        cols="3"
                        class="text-right"
                      >
                        <span class="font-weight-bold font-14">Total (RM)</span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters> 
                      <v-col
                        cols="3"
                        class="text-right"
                      >
                        <span class="font-weight-bold font-14">EPF</span>
                      </v-col>                    
                      <v-col
                        cols="3"
                        class="text-right font-14"
                      >
                        <span>{{ currencyFormatting(grandTotalNetEmployerEpf(payrollClosing.payroll_closing_details)) }}</span>
                      </v-col>
                      <v-col
                        cols="3" 
                        class="text-right font-14"
                      >
                        <span>{{ currencyFormatting(grandTotalNetEmployeeEpf(payrollClosing.payroll_closing_details)) }}</span>
                      </v-col>
                      <v-col
                        cols="3"
                        class="text-right font-14"
                      >
                        <span>{{ currencyFormatting(parseInt(grandTotalNetEmployerEpf(payrollClosing.payroll_closing_details) + grandTotalNetEmployeeEpf(payrollClosing.payroll_closing_details))) }}</span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters> 
                      <v-col
                        cols="3"
                        class="text-right"
                      >
                        <span class="font-weight-bold font-14">SOCSO</span>
                      </v-col>                    
                      <v-col
                        cols="3"
                        class="text-right font-14"
                      >
                        <span>{{ currencyFormatting(grandTotalNetEmployerSocso(payrollClosing.payroll_closing_details)) }}</span>
                      </v-col>
                      <v-col
                        cols="3" 
                        class="text-right font-14"
                      >
                        <span>{{ currencyFormatting(grandTotalNetEmployeeSocso(payrollClosing.payroll_closing_details)) }}</span>
                      </v-col>
                      <v-col
                        cols="3"
                        class="text-right font-14"
                      >
                        <span>{{ currencyFormatting(parseInt(grandTotalNetEmployerSocso(payrollClosing.payroll_closing_details) + grandTotalNetEmployeeSocso(payrollClosing.payroll_closing_details))) }}</span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters> 
                      <v-col
                        cols="3"
                        class="text-right"
                      >
                        <span class="font-weight-bold font-14">EIS</span>
                      </v-col>                    
                      <v-col
                        cols="3"
                        class="text-right font-14"
                      >
                        <span>{{ currencyFormatting(grandTotalNetEmployerEis(payrollClosing.payroll_closing_details)) }}</span>
                      </v-col>
                      <v-col
                        cols="3" 
                        class="text-right font-14"
                      >
                        <span>{{ currencyFormatting(grandTotalNetEmployeeEis(payrollClosing.payroll_closing_details)) }}</span>
                      </v-col>
                      <v-col
                        cols="3"
                        class="text-right font-14"
                      >
                        <span> {{ currencyFormatting(parseInt(grandTotalNetEmployerEis(payrollClosing.payroll_closing_details) + grandTotalNetEmployeeEis(payrollClosing.payroll_closing_details))) }}</span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters> 
                      <v-col
                        cols="3"
                        class="text-right"
                      >
                        <span class="font-weight-bold font-14">PCB</span>
                      </v-col>                    
                      <v-col cols="3" />
                      <v-col
                        cols="3" 
                        class="text-right font-14"
                      >
                        <span>{{ currencyFormatting(grandTotalNetPcb(payrollClosing.payroll_closing_details)) }}</span>
                      </v-col>
                      <v-col
                        cols="3"
                        class="text-right font-14"
                      >
                        <span>{{ currencyFormatting(grandTotalNetPcb(payrollClosing.payroll_closing_details)) }}</span>
                      </v-col>
                    </v-row>

                    <v-row no-gutters> 
                      <v-col
                        cols="3"
                        class="text-right "
                      >
                        <span class="font-weight-bold font-14">HRDF</span>
                      </v-col>                    
                      <v-col
                        cols="3"
                        class="text-right font-14"
                      >
                        <span>{{ currencyFormatting(payrollClosing.hrdf_wages) }}</span>
                      </v-col>
                      <v-col cols="3" />
                      <v-col
                        cols="3"
                        class="text-right font-14"
                      >
                        <span>{{ currencyFormatting(payrollClosing.hrdf_wages) }}</span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </div>

              <v-data-table
                v-model="selected"
                :loading="tableLoading"
                :headers="batchHeaders"
                :items="salaryBatches"
                class="mb-3"
                item-value="id"
              >
                <template v-slot:item="props">
                  <tr>
                    <td>
                      <a
                        style="color:black"
                        class="font-weight-bold"
                        @click="loadEmployeeSalaries(props.item.id)"
                      >
                        {{ props.item.name }}  
                      </a>
                    </td>
                    <td
                      :class="{
                        'warning--text':props.item.status.toUpperCase() ==='PENDING',
                        'green--text':props.item.status.toUpperCase() ==='COMPLETED',
                        'font-weight-bold':props.item.status.toUpperCase() ==='CLOSED'
                      }"
                    >
                      {{ props.item.status }}
                    </td>
                    <td>
                      {{ props.item.created_by }}
                    </td>
                    <td>
                      {{ $moment(props.item.created_at).format('D MMMM YYYY') }}
                    </td>
                    <td align="center">
                      <payroll-preparation-download-preview
                        :batch-id="props.item.id"
                        :status="props.item.status"
                        :company="company.name"
                        :salarymonth="formatSalaryMonth"
                        :showicon="true"
                      />
                        
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on: tooltip }">
                          <v-btn
                            v-show="props.item.status.toUpperCase()==='COMPLETED' || props.item.status.toUpperCase()==='CLOSED'"
                            icon 
                            v-on="{ ...tooltip }"
                            @click="template = true, batchId=props.item.id"
                          >
                            <v-icon color="primary">
                              mdi-bank
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Export To Bank</span>
                      </v-tooltip>
                    </td>
                    <td>
                      <payroll-preparation-menu-edit-batch 
                        v-if="props.item.status.toUpperCase() !=='COMPLETED' && props.item.status.toUpperCase()!=='CLOSED'"
                        :batch="props.item"
                        @updated="retrieve()"
                      />
                      <payroll-preparation-menu-delete-batch 
                        v-if="props.item.status.toUpperCase() !=='COMPLETED' && props.item.status.toUpperCase()!=='CLOSED'"
                        :batch-id="props.item.id"
                        @deleted="employees=[], retrieve()"
                      />
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <v-card-actions v-if="company && salaryMonth && (salaryBatches && salaryBatches.length > 0)">
                <v-spacer />
                <v-btn
                  v-if="false"
                  @click="testing"
                >
                  123
                </v-btn>
                <v-btn
                  v-if="!payrollClosing && isAllStatusCompleted"
                  color="success"
                  @click="beforePayrollClosed"
                >
                  Month End Closing
                </v-btn>
                <payroll-preparation-month-end-closing-report
                  v-if="payrollClosing"
                  :company="company"
                  :salarymonth="formatSalaryMonth"
                />
                <!-- <div
                  v-else
                  class="font-weight-bold text-right"
                >
                  Closed by {{ payrollClosing.created_by }} on {{ $moment(payrollClosing.created_at).format('D MMMM YYYY') }}
                </div> -->
              </v-card-actions>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-row
      v-show="isBatch"
      align="end"
      no-gutters
    >
      <v-col cols="6">
        <v-breadcrumbs 
          :items="navItems" 
          divider="/"
          class="py-0"
        >
          <template v-slot:item="props">
            <a
              v-if="!props.item.disabled"
              
              @click="updatePage"
            >{{ props.item.text }}</a>
            <span
              v-else
            >{{ batchData && batchData.name ? batchData.name : '' }}</span>
          </template>
        </v-breadcrumbs>
      </v-col>
      <v-col
        cols="6"
        class="font-weight-bold text-right"
      >
        <div>Company: {{ company && company.name ? company.name : '' }}</div>
        <div>Month: {{ formatSalaryMonth ? formatSalaryMonth : '' }}</div>
      </v-col>
    </v-row>
    <v-row
      v-show="isBatch"
      no-gutters
    >
      <v-col cols="12">
        <div
          v-if="employees && employees.length > 0"
          class=" summary-table-margin elevation-6 ma-0 my-3"
          style="background-color:white;width:100%"
        >
          <v-row no-gutters>
            <v-col class="text-center pt-2">
              <span class="font-weight-bold summary-header-font-size"><u>Batch Summary</u></span>
            </v-col>
          </v-row>
          <v-row
            no-gutters
          >
            <v-col cols="2" />
            <v-col
              cols="2"
              class="text-right"
            >
              <span class="font-weight-bold">Net Salary (RM)</span>
            </v-col>
            <v-col
              cols="1.5"
              class="text-right"
            >
              <span class="font-weight-bold">PCB (RM)</span>
            </v-col>
            <v-col
              cols="1.5"
              class="text-right"
            >
              <span class="font-weight-bold">EPF (RM)</span>
            </v-col>
            <v-col
              cols="1.5"
              class="text-right"
            >
              <span class="font-weight-bold">SOCSO (RM)</span>
            </v-col>
            <v-col
              cols="1.5"
              class="text-right"
            >
              <span class="font-weight-bold">EIS (RM)</span>
            </v-col>
            <v-col
              cols="2"
              class="text-right pr-5"
            >
              <span class="font-weight-bold">Total (RM)</span>
            </v-col>
          </v-row>
          <v-row
            no-gutters
          >
            <v-col
              cols="2"
              class="pl-5"
            >
              <span class="font-weight-bold">Employee</span>
            </v-col>
            <v-col
              cols="2"
              class="text-right pr-3"
            >
              {{ currencyFormatting(grandTotalNetSalary(employees)) }}
            </v-col>
            <v-col
              cols="1.5"
              class="text-right pr-3"
            >
              {{ currencyFormatting(grandTotalNetPcb(employees)) }}
            </v-col>
            <v-col
              cols="1.5"
              class="text-right pr-3"
            >
              {{ currencyFormatting(grandTotalNetEmployeeEpf(employees)) }}
            </v-col>
            <v-col
              cols="1.5"
              class="text-right pr-3"
            >
              {{ currencyFormatting(grandTotalNetEmployeeSocso(employees)) }}
            </v-col>
            <v-col
              cols="1.5"
              class="text-right pr-3"
            >
              {{ currencyFormatting(grandTotalNetEmployeeEis(employees)) }}
            </v-col>
            <v-col
              cols="2"
              class="text-right pr-5"
            >
              {{ currencyFormatting(grandTotalGrossSalary(employees)) }}
            </v-col>
          </v-row>
          <v-row
            no-gutters
          >
            <v-col
              cols="2"
              class="pl-5"
            >
              <span class="font-weight-bold">Employer</span>
            </v-col>
            <v-col cols="2" />
            <v-col
              cols="1.5"
              class="text-right pr-3"
            />
            <v-col
              cols="1.5"
              class="text-right pr-3"
            >
              {{ currencyFormatting(grandTotalNetEmployerEpf(employees)) }}
            </v-col>
            <v-col
              cols="1.5"
              class="text-right pr-3"
            >
              {{ currencyFormatting(grandTotalNetEmployerSocso(employees)) }}
            </v-col>
            <v-col
              cols="1.5"
              class="text-right pr-3"
            >
              {{ currencyFormatting(grandTotalNetEmployerEis(employees)) }}
            </v-col>
            <v-col
              cols="2"
              class="text-right pr-5"
            >
              {{ currencyFormatting(parseInt(grandTotalNetEmployerEpf(employees) + grandTotalNetEmployerSocso(employees)) + grandTotalNetEmployerEis(employees)) }}
            </v-col>
          </v-row>
            
          <v-divider />
          <v-row
            no-gutters
            style="border-top:1px solid black"
          >
            <v-col
              cols="2"
              class="pl-5 pb-2"
            >
              <span
                class="font-weight-bold"
              >Total</span>
            </v-col>
            <v-col
              cols="2"
              class="font-weight-medium text-right pr-3"
            >
              {{ currencyFormatting(grandTotalNetSalary(employees)) }}
            </v-col>
            <v-col
              cols="1.5"
              class="font-weight-medium text-right pr-3"
            >
              {{ currencyFormatting(grandTotalNetPcb(employees)) }}
            </v-col>
            <v-col
              cols="1.5"
              class="font-weight-medium text-right pr-3"
            >
              {{ currencyFormatting(parseInt(grandTotalNetEmployerEpf(employees) + grandTotalNetEmployeeEpf(employees))) }}
            </v-col>
            <v-col
              cols="1.5"
              class="font-weight-medium text-right pr-3"
            >
              {{ currencyFormatting(parseInt(grandTotalNetEmployerSocso(employees) + grandTotalNetEmployeeSocso(employees))) }}
            </v-col>
            <v-col
              cols="1.5"
              class="font-weight-medium text-right pr-3"
            >
              {{ currencyFormatting(parseInt(grandTotalNetEmployerEis(employees) + grandTotalNetEmployeeEis(employees))) }}
            </v-col>
            <v-col
              cols="2"
              class="font-weight-medium text-right pr-5"
            >
              {{ 
                currencyFormatting(parseInt(
                  grandTotalNetSalary(employees) 
                    + grandTotalNetPcb(employees) 
                    + grandTotalNetEmployerEpf(employees) + grandTotalNetEmployeeEpf(employees)
                    + grandTotalNetEmployerSocso(employees) + grandTotalNetEmployeeSocso(employees)
                    + grandTotalNetEmployerEis(employees) + grandTotalNetEmployeeEis(employees)
                )) 
              }}
            </v-col>
          </v-row>
        </div>
        <v-card class="elevation-10">
          <v-row no-gutters>
            <v-col cols="12">
              <v-data-table
                v-model="selected"
                :loading="tableLoading"
                :headers="headers"
                :items="employees"
                show-expand
                :show-select="disableShowSelect?true:false"
                class="mb-3"
                item-value="id" 
                single-expand
              >
                <template v-slot:item="props">
                  <tr>
                    <td
                      v-if="disableShowSelect"
                      :class="props.isExpanded? 'remove-bottom-border selectedRow':'border-bottom'"
                    >
                      <v-simple-checkbox
                        :class="props.isSelected? 'remove-bottom-border selectedRow':'border-bottom'"
                        :value="props.isSelected"
                        :ripple="false"
                        @input="props.select($event)"
                      />
                    </td> 

                    <td :class="props.isExpanded? 'remove-bottom-border selectedRow':'border-bottom'"> 
                      <a
                        style="margin-left:10px;color:black;font-weight:bold" 
                        @click="props.expand(!props.isExpanded)"
                      >
                        <span :class="props.isExpanded? 'font-weight-bold':''">{{ props.item.company_employee.employee.person.name }}</span>                 
                      </a>
                    </td>

                    <td :class="props.isExpanded? 'remove-bottom-border text-right selectedRow':'border-bottom text-right'"> 
                      <span :class="props.isExpanded? 'font-weight-bold':''">{{ currencyFormatting(props.item.current_net_salary) }}</span>
                    </td>

                    <td :class="props.isExpanded? 'remove-bottom-border text-right selectedRow':'border-bottom text-right'"> 
                      <span :class="props.isExpanded? 'font-weight-bold':''">{{ currencyFormatting(props.item.current_pcb_paid) }}</span>
                    </td>

                    <td :class="props.isExpanded? 'remove-bottom-border align-center selectedRow':'border-bottom align-center'">
                      <span :class="props.isExpanded? 'font-weight-bold':''">{{ props.item.employee_working_days }} / {{ props.item.current_month_working_days }}</span>
                    </td>

                    <td :class="props.isExpanded? 'remove-bottom-border align-center selectedRow':'border-bottom align-center'">
                      <span
                        :class="{
                          'warning--text':props.item.status ==='Pending' && !props.isExpanded,
                          'info--text':props.item.status ==='Confirmed' && !props.isExpanded,
                          'green--text':props.item.status ==='Completed' && !props.isExpanded,
                          'font-weight-bold':props.isExpanded || props.item.status ==='Closed'
                        }"
                      >
                        {{ props.item.status }}
                      </span>
                    </td>

                    <td :class="props.isExpanded? 'remove-bottom-border align-center selectedRow':'border-bottom align-center'">
                      <payroll-preparation-dialog-confirmation
                        :salary="props.item"
                        @updated="loadEmployees"
                      />
                    </td>

                    <td :class="props.isExpanded? 'remove-bottom-border selectedRow':'border-bottom'">
                      <v-btn
                        icon
                        @click="props.expand(!props.isExpanded)"
                      >
                        <v-icon small> 
                          {{ props.isExpanded ? 'fa-chevron-up selectedRow':'fa-chevron-down' }} 
                        </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>

                <template v-slot:expanded-item="{ headers, item }">    
                  <td
                    :colspan="12"
                    class="selectedRow"
                  >
                    <div class="pb-2 px-2 mb-2">
                      <v-data-table
                        :loading="detailLoading"
                        dense
                        :items="item.salary_details"
                        :headers="detailHeaders"
                        hide-default-footer
                        hide-default-header
                        class="header-border disable-pointer-event "
                      >
                        <template v-slot:header="{}">
                          <thead class="v-data-table-header ">
                            <tr>
                              <th />
                              <th />
                              <th
                                colspan="4"
                                class="text-center customised-header header-border-left header-border-bottom"
                              >
                                Employee (RM)
                              </th>
                              <th
                                colspan="3"
                                class="text-center customised-header header-border-right header-border-left header-border-bottom"
                              >
                                Employer (RM)
                              </th>
                              <th
                                rowspan="2"
                                class="text-center"
                                width="110"
                              >
                                <payroll-preparation-dialog-create
                                  v-if="(batchData.status.toUpperCase()!=='COMPLETED' && batchData.status.toUpperCase()!=='CLOSED')"
                                  :payroll="item"
                                  @created="loadEmployees"
                                />
                              </th>
                            </tr>

                            <tr>
                              <th class="text-left customised-header">
                                Name & Remarks
                              </th>

                              <th
                                class="text-center customised-header"
                                width="150"
                              >
                                Amount (RM)
                              </th>

                              <th
                                class="text-center customised-header  header-border-left header-border-bottom"
                                width="120"
                              >
                                PCB
                              </th>

                              <th
                                class="text-center customised-header header-border-left header-border-bottom"
                                width="120"
                              >
                                EPF
                              </th>
                          
                              <th
                                class="text-center customised-header header-border-left header-border-bottom"
                                width="120"
                              >
                                SOCSO
                              </th>

                              <th
                                class="text-center customised-header header-border-left header-border-bottom"
                                width="120"
                              >
                                EIS
                              </th>

                              <th
                                class="text-center customised-header header-border-left header-border-bottom"
                                width="120"
                              >
                                EPF
                              </th>

                              <th
                                class="text-center customised-header header-border-left header-border-bottom"
                                width="120"
                              >
                                SOCSO
                              </th>

                              <th
                                class="text-center customised-header header-border-right header-border-left header-border-bottom"
                                width="120"
                              >
                                EIS
                              </th>
                            </tr>
                          </thead>
                        </template>

                        <template v-slot:item="props">
                          <tr>
                            <td>
                              <div>
                                <span class="font-weight-medium">{{ props.item.allowance_penalty_type.name }}</span>
                              </div>
                              <div
                                v-if="props.item.remarks"
                                style="text-align:justify;white-space:pre-line"
                              >
                                <span style="font-size:10pt;text-align:justify">{{ props.item.remarks }}</span>
                              </div>
                            </td>

                            <td class="text-right">
                              <span v-if="props.item.allowance_penalty_type.is_negative && props.item.amount > 0"> 
                                -{{ currencyFormatting(props.item.amount) }}
                              </span>
                              <span v-else> 
                                {{ currencyFormatting(props.item.amount) }}
                              </span>
                            </td>

                            <td class="text-right header-border-left">
                              <span v-if="props.item.allowance_penalty_type.is_negative && props.item.pcb_amount > 0"> 
                                -{{ currencyFormatting(props.item.pcb_amount) }}
                              </span>
                              <span v-else> 
                                {{ currencyFormatting(props.item.pcb_amount) }}
                              </span>
                            </td>

                            <td class="text-right">
                              <span v-if="props.item.allowance_penalty_type.is_negative && props.item.employee_epf_amount > 0"> 
                                -{{ currencyFormatting(props.item.employee_epf_amount) }}
                              </span>
                              <span v-else> 
                                {{ currencyFormatting(props.item.employee_epf_amount) }}
                              </span>
                            </td>

                            <td class="text-right">
                              <span v-if="props.item.allowance_penalty_type.is_negative && props.item.employee_socso_amount > 0"> 
                                -{{ currencyFormatting(props.item.employee_socso_amount) }}
                              </span>
                              <span v-else> 
                                {{ currencyFormatting(props.item.employee_socso_amount) }}
                              </span>
                            </td>

                            <td class="text-right header-border-right">
                              <span v-if="props.item.allowance_penalty_type.is_negative && props.item.employee_eis_amount > 0"> 
                                -{{ currencyFormatting(props.item.employee_eis_amount) }}
                              </span>
                              <span v-else> 
                                {{ currencyFormatting(props.item.employee_eis_amount) }}
                              </span>
                            </td>

                            <td class="text-right">
                              <span v-if="props.item.allowance_penalty_type.is_negative && props.item.employer_epf_amount > 0"> 
                                -{{ currencyFormatting(props.item.employer_epf_amount) }}
                              </span>
                              <span v-else> 
                                {{ currencyFormatting(props.item.employer_epf_amount) }}
                              </span>
                            </td>

                            <td class="text-right">
                              <span v-if="props.item.allowance_penalty_type.is_negative && props.item.employer_socso_amount > 0"> 
                                -{{ currencyFormatting(props.item.employer_socso_amount) }}
                              </span>
                              <span v-else> 
                                {{ currencyFormatting(props.item.employer_socso_amount) }}
                              </span>
                            </td>

                            <td class="text-right header-border-right">
                              <span v-if="props.item.allowance_penalty_type.is_negative && props.item.employer_eis_amount > 0"> 
                                -{{ currencyFormatting(props.item.employer_eis_amount) }}
                              </span>
                              <span v-else> 
                                {{ currencyFormatting(props.item.employer_eis_amount) }}
                              </span>
                            </td>

                            <td>
                              <payroll-preparation-dialog-edit
                                v-if="(batchData.status.toUpperCase()!=='COMPLETED' && batchData.status.toUpperCase()!=='CLOSED')"
                                :payroll="props.item"
                                @updated="loadEmployees"
                              />

                              <payroll-preparation-dialog-delete
                                v-if="(batchData.status.toUpperCase()!=='COMPLETED' && batchData.status.toUpperCase()!=='CLOSED')"
                                :payroll="props.item"
                                @deleted="loadEmployees"
                              />
                            </td>
                          </tr>
                        </template>

                        <template v-slot:body.append>
                          <tr v-if="item && item.salary_details && item.salary_details.length > 0">
                            <td class="footer-td text-right">
                              <span class="font-weight-medium">Total: </span>
                            </td>

                            <td class="text-right">
                              <span class="font-weight-medium"> {{ currencyFormatting(item.current_gross_salary) }}</span>
                            </td>

                            <td class="text-right header-border-left">
                              <span class="font-weight-medium"> {{ currencyFormatting(item.current_pcb_paid) }}</span>
                            </td>

                            <td class="text-right">
                              <span class="font-weight-medium"> {{ currencyFormatting(item.current_epf_employee_contributed) }}</span>
                            </td>

                            <td class="text-right">
                              <span class="font-weight-medium"> {{ currencyFormatting(item.current_socso_employee_contributed) }}</span>
                            </td>

                            <td class="text-right header-border-right">
                              <span class="font-weight-medium"> {{ currencyFormatting(item.current_eis_employee_contributed) }}</span>
                            </td>

                            <td class="text-right">
                              <span class="font-weight-medium"> {{ currencyFormatting(item.current_epf_employer_contributed) }}</span>
                            </td>

                            <td class="text-right">
                              <span class="font-weight-medium"> {{ currencyFormatting(item.current_socso_employer_contributed) }}</span>
                            </td>

                            <td class="text-right header-border-right">
                              <span class="font-weight-medium"> {{ currencyFormatting(item.current_eis_employer_contributed) }}</span>
                            </td>

                            <td>
                              <span />
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </div>
                  </td>
                </template>
              </v-data-table>
              <v-card-actions>
                <v-spacer />
                <payroll-preparation-download-preview
                  v-if="batchData"
                  :batch-id="batchId"
                  :status="batchData.status"
                  :company="company.name"
                  :salarymonth="formatSalaryMonth"
                  :salarydate="salaryMonth ? $moment(salaryMonth + '-01'):''"
                  :showicon="false"
                />

                <v-btn
                  v-if="(batchData && batchData.status.toUpperCase()!=='COMPLETED' && batchData.status.toUpperCase()!=='CLOSED')"
                  color="success"
                  :disabled="selected.length<=0"
                  @click="checkout"
                >
                  Checkout
                </v-btn>

                <v-btn
                  v-if="(batchData && batchData.status.toUpperCase()==='COMPLETED')"
                  color="success"
                  @click="revert"
                >
                  Revert
                </v-btn>

                <v-btn
                  v-else-if="(batchData && batchData.status.toUpperCase()==='COMPLETED')"
                  color="primary"
                  @click="template = true"
                >
                  Export to bank
                </v-btn>
              </v-card-actions>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="batchDialog"
      persistent
      max-width="400px"
    > 
      <material-card
        :offset="10"
        :full-width="true"
        color="green"
        title="Company Salary"
        text="Preparing Batch Name"
        class="mb-0"
      >
        <v-container v-if="batchDialog">
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                label="Batch Name"
                data-vv-name="name"
                data-vv-as="batch name"
                :error-messages="errors.collect('name')"
              />  
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>  
          <v-spacer />
          <v-btn
            :disabled="batchProgressing"
            text
            @click="name = null;batchDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            :loading="batchProgressing"
            color="success"          
            @click="generate"
          >
            Create
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
      
    <v-dialog
      v-model="existingBatchDialog"
      persistent
      max-width="400px"
    > 
      <material-card
        :offset="10"
        :full-width="true"
        color="warning"
        title="Warning for Create Batch"
        class="mb-0"
      >
        <v-container v-if="existingBatchDialog">
          <v-row no-gutters>
            <v-col
              cols="12"
            >
              There is/are existing payroll batch(es) on <span class="font-weight-bold">{{ formatSalaryMonth }}</span> under <span class="font-weight-bold">{{ company.name }}</span>. Please proceed if you wish to create another new batch.
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>  
          <v-spacer />
          <v-btn
            :disabled="existingBatchProgressing"
            text
            @click="existingBatchDialog=false"
          >
            Cancel
          </v-btn>
          <v-btn
            :loading="existingBatchProgressing"
            color="warning"          
            @click="existingBatchDialog=false, batchDialog=true"
          >
            Proceed
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <v-dialog
      v-model="checkoutDialog"
      persistent
      max-width="400px"
    > 
      <material-card
        :offset="10"
        :full-width="true"
        color="warning"
        title="Warning for Checkout"
        class="mb-0"
      >
        <v-container v-if="checkoutDialog">
          <v-row no-gutters>
            <v-col
              v-if="selected.length < employees.length"
              cols="12"
            >
              You have selected <span class="font-weight-bold error--text">{{ selected.length }} of {{ employees.length }}</span>. For those un-selected payroll will be eliminated from this batch after checkout. Are you sure you want to proceed?
            </v-col>
            <v-col
              v-else
              cols="12"
            >
              Are you sure you want to checkout?
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>  
          <v-spacer />
          <v-btn
            :disabled="checkoutProgressing"
            text
            @click="checkoutDialog = false"
          >
            No
          </v-btn>
          <v-btn
            :loading="checkoutProgressing"
            color="warning"          
            @click="confirmCheckout"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <v-dialog
      v-model="revertDialog"
      persistent
      max-width="400px"
    > 
      <material-card
        :offset="10"
        :full-width="true"
        color="warning"
        title="Warning for Revert Batch Payroll"
        class="mb-0"
      >
        <v-container v-if="revertDialog">
          <v-row no-gutters>
            <v-col
              cols="12"
            >
              Are you sure you want to revert current batch payroll?
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>  
          <v-spacer />
          <v-btn
            :disabled="revertProgressing"
            text
            @click="revertDialog = false"
          >
            No
          </v-btn>
          <v-btn
            :loading="revertProgressing"
            color="warning"          
            @click="confirmRevert"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <v-dialog
      v-model="warningDialog"
      persistent
      max-width="400px"
    > 
      <material-card
        :offset="10"
        :full-width="true"
        color="warning"
        title="Warning for Checkout"
        class="mb-0"
      >
        <v-container v-if="warningDialog">
          <v-row no-gutters>
            <v-col cols="12">
              Selected data contains status with <span class="font-weight-bold warning--text">Pending</span>. Please check and change the status to <span class="font-weight-bold info--text">Confirmed</span> before <span class="font-weight-bold">Checkout</span>.
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>  
          <v-spacer />
          <v-btn
            :disabled="warningProgressing"
            color="warning"
            @click="warningDialog = false, containsPending = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <v-dialog
      v-model="payrollClosingDialog"
      persistent
      max-width="400px"
    > 
      <material-card
        :offset="10"
        :full-width="true"
        color="success"
        title="Month End Closing"
        class="mb-0"
      >
        <v-container v-if="payrollClosingDialog">
          <v-row no-gutters>
            <v-col
              cols="12"
            >
              This month's payroll will <span class="font-weight-bold">not able to edit</span> after <span class="font-weight-bold green--text">closed</span>. Are you sure you want to proceed?
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>  
          <v-spacer />
          <v-btn
            :disabled="payrollClosingLoading"
            text
            @click="payrollClosingDialog = false"
          >
            No
          </v-btn>
          <v-btn
            :loading="payrollClosingLoading"
            color="success"          
            @click="monthEndClosing"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <v-dialog
      v-model="payrollClosingWarningDialog"
      persistent
      max-width="400px"
    > 
      <material-card
        :offset="10"
        :full-width="true"
        color="warning"
        title="Month End Closing"
        class="mb-0"
      >
        <v-container v-if="payrollClosingWarningDialog">
          <v-row no-gutters>
            <v-col
              v-if="payrollClosing"
              cols="12"
            >
              Current month's Payroll is <span class="font-weight-bold green--text">closed</span>. Unable to create new batch.
            </v-col>
            <v-col
              v-else-if="openBatches && openBatches.length>0"
              cols="12"
            >
              <span class="font-weight-bold">{{ selectedFormatSalaryMonth(openBatches[0].date)+"'s" }} payroll is not yet closed. </span>Please close it before you create new batch.
            </v-col>
            <v-col
              v-else-if="futureBatches && futureBatches.length>0"
              cols="12"
            >
              There is payroll on <span class="font-weight-bold">{{ selectedFormatSalaryMonth(futureBatches[0].date) }}</span>. You are not allowed to create backdated payroll.
            </v-col>
            <v-col
              v-else
              cols="12"
            />
          </v-row>
        </v-container>

        <v-card-actions>  
          <v-spacer />
          <v-btn
            text
            color="warning"
            @click="payrollClosingWarningDialog = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <v-dialog
      v-model="template"
      persistent
      max-width="800px"
    >
      <material-card
        :offset="10"
        :full-width="true"
        color="success"
        title="Generate Bank Report"
        text="Select Report Template"
        class="mb-0"
      >
        <v-container v-if="template">
          <v-row no-gutters>
            <v-col
              cols="6"
              class="pr-1"
            >
              <v-autocomplete
                v-model="bankTemplate"
                v-validate="'required'"
                :error-messages="errors.collect('bankTemplate')"
                data-vv-name="bankTemplate"    
                data-vv-as="bank template"    
                label="Bank Template"
                :items="bankTemplates"
                item-text="payroll_bank.name"
                item-value="id"
                hide-no-data
                hide-selected
                return-object
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <span class="font-weight-bold">{{ item.payroll_bank.name }}</span>
                    <span>{{ item.bank_account_no }}</span>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col
              cols="6"
              class="pl-1"
            >
              <v-autocomplete  
                v-model="recordType"
                v-validate="'required'"
                label="Record Type"
                :error-messages="errors.collect('recordType')"
                data-vv-name="recordType"    
                data-vv-as="record type"    
                :items="recordTypes"
                item-text="name"
                item-value="code"
              />
            </v-col>
          </v-row>

          <div class="text-center">
            <v-progress-circular
              v-if="retrieving"
              color="primary"
              indeterminate
            />
        
            <div
              v-else-if="processedDatas.length>0"
              class="employee-listing px-3"
            >
              <v-row
                v-for="(processedData,index) in processedDatas"
                :key="index"
                no-gutters
              >
                <v-col
                  cols="4"
                  class="pr-1"
                >
                  <v-text-field
                    label="Employee Name"
                    :value="processedData.company_employee.employee.person.name"
                    disabled
                  />
                </v-col>
                <v-col
                  cols="4"
                  class="pr-1"
                >
                  <v-text-field
                    label="Employee Bank"
                    :value="processedData.company_employee.employee.bank.name"
                    disabled
                  />
                </v-col>
                <v-col cols="4">
                  <v-autocomplete
                    v-model="processedData.record_type"
                    :items="recordTypes"
                    label="Record Type"
                    item-text="name"
                    item-value="code"
                  />
                </v-col>
              </v-row>
            </div>

            <div v-else>
              No data available
            </div>
          </div>
        </v-container>

        <v-card-actions>  
          <v-spacer />
          <v-btn
            :disabled="warningProgressing"
            text
            @click="template = false; bankTemplate = null;recordType = null;processedDatas = []"
          >
            Close
          </v-btn>
          <v-btn
            color="success"
            :loading="downloading"
            @click="download"
          >
            Download
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    components: {
      PayrollPreparationDialogCreate: () => import('@/components/payroll/preparation/DialogCreate'),
      PayrollPreparationDialogEdit: () => import('@/components/payroll/preparation/DialogEdit'), 
      PayrollPreparationDialogDelete: () => import('@/components/payroll/preparation/DialogDelete'), 
      PayrollPreparationDialogConfirmation: () => import('@/components/payroll/preparation/DialogConfirmation'),
      PayrollPreparationMenuDeleteBatch: () => import('@/components/payroll/preparation/MenuDeleteBatch'),
      PayrollPreparationMenuEditBatch: () => import('@/components/payroll/preparation/MenuEditBatch'),
      PayrollPreparationDownloadPreview: () => import('@/components/payroll/preparation/DownloadPreview'),
      PayrollPreparationMonthEndClosingReport: () => import('@/components/payroll/preparation/MonthEndClosingReport'),
    },
    inject: ['$validator'],
    data () {
      return {
        template: false,
        company: null,
        companies: [],
        salaryMonth: null,
        menu: false,
        salaryBatches: [],
        batchHeaders: [
          {
            text: 'Batch Name',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Status',
            align: 'left',
            value: 'status',
          },
          {
            text: 'Created By',
            align: 'left',
            value: 'created_by',
          },
          {
            text: 'Created At',
            align: 'left',
            value: 'created_at',
          },
          {
            text: 'Reports',
            align: 'center',
            value: 'reports',
            sortable: false,
          },
          {
            sortable: false,
            value: 'action',
          },
        ],
        batchProgressing: false,
        existingBatchProgressing: false,
        pendingBatches: [],
        existingBatchDialog: false,
        batchDialog: false,
        tableLoading: false,
        selected: [],
        name: null,
        batchId: null,

        isBatch: false,
        employees: [],
        batchData: null,
        detailLoading: false,
        salaryIds: [],
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'company_employee.employee.person.name',
          },
          {
            text: 'Salary (RM)',
            align: 'right',
            value: 'current_net_salary',
          },
          {
            text: 'PCB (RM)',
            align: 'right',
            value: 'current_pcb_paid',
          },
          {
            text: 'No. of Working Days',
            align: 'center',
          },
          {
            text: 'Status',
            align: 'center',
            value: 'status',
          },
          {
            text: 'Is Checked?',
            align: 'center',
            value: 'action',
          },
          {
            text: '',
            value: 'data-table-expand', 
          },
        ],
        detailHeaders: [
          {
            text: 'Name',
            align: 'left',
            value: 'allowance_penalty_type.name',
            sortable: false,
          }, 
          {
            text: 'Amount(RM)',
            align: 'right',
            value: 'amount',
            sortable: false,
          }, 
          {
            text: 'PCB(RM)',
            align: 'right',
            value: 'pcb_amount',
            sortable: false,
          }, 
          {
            text: 'EE Epf(RM)',
            align: 'right',
            value: 'employee_epf_amount',
            sortable: false,
          }, 
          {
            text: 'EE Socso(RM)',
            align: 'right',
            value: 'employee_socso_amount',
            sortable: false,
          }, 
          {
            text: 'EE EIS(RM)',
            align: 'right',
            value: 'employee_eis_amount',
            sortable: false,
          }, 
          {
            text: 'ER Epf(RM)',
            align: 'right',
            value: 'employer_epf_amount',
            sortable: false,
          }, 
          {
            text: 'ER Socso(RM)',
            align: 'right',
            value: 'employer_socso_amount',
            sortable: false,
          }, 
          {
            text: 'ER EIS(RM)',
            align: 'right',
            value: 'employer_eis_amount',
            sortable: false,
          }, 
          {
            text: '',
            align: 'center',
            value: 'action',
            sortable: false,
          }, 
        ],
        // profile navigation
        navItems: [
          {
            text: 'Payroll Preparation',
            disabled: false,
          },
          {
            text: 'Batch',
            disabled: true,
          },
        ],

        bankTemplates: [],
        bankTemplate: null,
        recordType: null,
        search: '',
        generating: false,
        // batchListingDialog: false,
        batchListingProgressing: false,
        batch: 0, 
        batches: [],
        containsPending: false,
        checkoutDialog: false,
        checkoutProgressing: false,
        warningDialog: false,
        warningProgressing: false,
        processedDatas: [],
        retrieving: false,
        downloading: false,

        payrollClosing: null,
        payrollClosingDialog: false,
        payrollClosingLoading: false,
        isAllStatusCompleted: false,
        payrollClosingWarningDialog: false,
        openBatch: null,
        openBatches: [],
        futureBatches: [],

        revertDialog: false,
        revertProgressing: false,
      }
    },
    computed: {
      formatSalaryMonth () {
        return this.salaryMonth ? this.$moment(this.salaryMonth + '-01').format('MMM YYYY') : ''
      },
      recordTypes () {
        if (!this.bankTemplate) return []
        return this.bankTemplates.find(template => { return template.id === this.bankTemplate.id }).payroll_bank.record_types
      },
      isFilled () {
        if (!this.bankTemplate || !this.recordType) return false

        return true
      },
      
      templateRoute () {
        if (!this.bankTemplate) return
        return this.bankTemplate.payroll_bank.name.toLowerCase().replaceAll(' ', '-')
      },

      fileName () {
        if (!this.salaryMonth) return 

        return 'Payroll_' + this.$moment(this.salaryMonth).format('MMMM YYYY').replaceAll(' ', '_')
      },

      disableShowSelect () {
        if (!this.batchData) return

        return this.batchData.status.toUpperCase() !== 'COMPLETED' && this.batchData.status.toUpperCase() !== 'CLOSED'
      },
    },

    watch: {
      template: function (value) {
        if (value) {
          this.loadBankTemplate()
        }
      }, 
      isFilled: function (value) {
        if (value) {
          this.loadPayrollEmployees()
        }
      },
      company: {
        handler (value) {
          if (value && this.salaryMonth) {
            this.retrieve()
          }
        },
      },
      salaryMonth: {
        handler (value) {
          if (value && this.company) {
            this.retrieve()
          }
        },
      },
    },

    created () {
      this.loadCompanies()
    },

    methods: {
      resetSalaryMonth () {
        this.salaryMonth = null
        this.salaryBatches = []
        this.payrollClosing = null
      },
      selectedFormatSalaryMonth (selectedMonth) {
        return selectedMonth ? this.$moment(selectedMonth).format('MMM YYYY') : ''
      },

      grandTotalNetSalary (employees) {
        let sum = 0
        for (let item in employees) {
          sum = parseInt(sum) + parseInt(employees[item].current_net_salary)
        }
        return sum
      },
      grandTotalGrossSalary (employees) {
        let sum = 0
        for (let item in employees) {
          sum = parseInt(sum) + parseInt(employees[item].current_gross_salary)
        }
        return sum
      },
      grandTotalNetPcb (employees) {
        let sum = 0
        for (let item in employees) {
          sum = parseInt(sum) + parseInt(employees[item].current_pcb_paid)
        }
        return sum
      },
      grandTotalNetEmployeeEpf (employees) {
        let sum = 0
        for (let item in employees) {
          sum = parseInt(sum) + parseInt(employees[item].current_epf_employee_contributed)
        }
        return sum
      },
      grandTotalNetEmployeeSocso (employees) {
        let sum = 0
        for (let item in employees) {
          sum = parseInt(sum) + parseInt(employees[item].current_socso_employee_contributed)
        }
        return sum
      },
      grandTotalNetEmployeeEis (employees) {
        let sum = 0
        for (let item in employees) {
          sum = parseInt(sum) + parseInt(employees[item].current_eis_employee_contributed)
        }
        return sum
      },
      grandTotalNetEmployerEpf (employees) {
        let sum = 0
        for (let item in employees) {
          sum = parseInt(sum) + parseInt(employees[item].current_epf_employer_contributed)
        }
        return sum
      },
      grandTotalNetEmployerSocso (employees) {
        let sum = 0
        for (let item in employees) {
          sum = parseInt(sum) + parseInt(employees[item].current_socso_employer_contributed)
        }
        return sum
      },
      grandTotalNetEmployerEis (employees) {
        let sum = 0
        for (let item in employees) {
          sum = parseInt(sum) + parseInt(employees[item].current_eis_employer_contributed)
        }
        return sum
      },
      download () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.downloading = true

            this.$api.payrollExport().download(this.templateRoute, { data: this.processedDatas, fileName: this.fileName, company_uid: this.company.id, bankTemplate: this.bankTemplate })
              .then(res => {
                let blob = new Blob([res.data], { type: res.data.type })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.setAttribute('download', this.fileName + ((res.data.type === 'text/plain') || (res.data.type === 'text/html') ? '.txt' : '.xlsx'))
                link.click()

                this.downloading = false
                this.template = false
                this.bankTemplate = null
                this.processedDatas = []
                this.recordType = null
              })
              .catch(() => {
                this.downloading = false
              })
          })
      },

      loadPayrollEmployees () {
        this.retrieving = true

        this.$api.payrollExport().list(this.batchId)
          .then(res => {
            let temp = res.data
            temp.map(data => {
              if (data.company_employee.employee.bank.shift_code === this.bankTemplate.shift_code) {
                data.record_type = this.bankTemplate.record_types[0].code
              } else {
                data.record_type = this.recordType
              }
            })
            
            this.processedDatas = temp
            this.retrieving = false
          })
      },

      loadBankTemplate () {
        this.$api.companyBanks().templateList(this.company.id)
          .then(res => {
            this.bankTemplates = res.data
          })
      },

      loadCompanies () {
        this.$api.companies().list()
          .then(res => {
            this.companies = _.orderBy(res.data, ['name'], ['asc'])     
          })
      },

      beforeGenerate () {
        this.batches = []
        this.pendingBatches = []
        this.openBatches = []
        this.futureBatches = []

        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.existingBatchProgressing = true

            this.$api.companySalaryBatch().list(this.company.id)
              .then((batches) => {
                if (batches.data && batches.data.length > 0) {
                  this.batches = this.getCurrentMonthBatches(batches.data)
                  this.batches = _.orderBy(this.batches, ['created_at', 'name'], ['desc', 'asc'])

                  this.pendingBatches = this.getCurrentMonthPendingBatches(batches.data)
                  this.pendingBatches = _.orderBy(this.pendingBatches, ['created_at', 'name'], ['desc', 'asc'])

                  this.openBatches = this.getOpenBatches(batches.data)
                  this.openBatches = _.orderBy(this.openBatches, ['date'], ['desc'])

                  this.futureBatches = this.checkFutureBatches(batches.data)
                  this.futureBatches = _.orderBy(this.futureBatches, ['date'], ['asc'])
                }

                if (this.payrollClosing) {
                  this.payrollClosingWarningDialog = true
                } else if ((this.batches && this.batches.length > 0)) {
                  this.existingBatchDialog = true
                } else if (this.pendingBatches && this.pendingBatches.length > 0) {
                  this.existingBatchDialog = true
                } else if (this.openBatches && this.openBatches.length > 0) {
                  this.payrollClosingWarningDialog = true
                } else if (this.futureBatches && this.futureBatches.length > 0) {
                  this.payrollClosingWarningDialog = true
                } else {
                  this.existingBatchDialog = false
                  this.payrollClosingWarningDialog = false
                  this.batchDialog = true
                }
              })

            this.existingBatchProgressing = false
          })
      },

      getLastDayOfMonth (salaryMonth) {
        return this.$moment(salaryMonth + '-01').endOf('month').format('YYYY-MM-DD')
      },

      getCurrentMonthBatches (batches) {
        return batches.filter(batch => {
          return batch.date === this.getLastDayOfMonth(this.salaryMonth)
        })
      },

      getCurrentMonthPendingBatches (batches) {
        return batches.filter(batch => {
          return batch.date === this.getLastDayOfMonth(this.salaryMonth) && batch.status === 'Pending'
        })
      },

      getOpenBatches (batches) {
        return batches.filter(batch => {
          return batch.status !== 'Closed'
        })
      },

      checkFutureBatches (batches) {
        return batches.filter(batch => {
          return batch.date > this.getLastDayOfMonth(this.salaryMonth)
        })
      },

      generate () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.batchProgressing = true

            this.$api.payroll().create(this.prepareFormData())
              .then(payroll => {
                this.batchProgressing = false

                this.batchDialog = false
                this.name = null
                if (payroll.status === 201) {
                  this.loadEmployeeSalaries(payroll.data.data.id) 
                } else if (payroll.status === 200) {
                  this.$snack({ color: 'red', message: 'Invalid salary month' })
                }
              })
          })
      },

      prepareFormData () {
        return {
          date: this.salaryMonth, 
          company_uid: this.company.id, 
          name: this.name,
          salaryMonth: this.salaryMonth,
        }
      },

      loadEmployeeSalaries (batchId) {
        this.batchId = batchId
        this.tableLoading = true

        Promise.all([
          this.$api.companySalaryBatch().show(this.batchId),
          this.$api.payroll().list(this.batchId),
        ])
          .then(([selectedBatch, payrollList]) => {
            this.batchData = selectedBatch.data
            this.employees = _.orderBy(payrollList.data, ['company_employee.employee.person.name'], ['asc'])
            
            this.isBatch = true
            this.tableLoading = false
            this.selected = []
            // this.batchListingDialog = false
          })
      },

      checkout () {
        this.selected.forEach(item => {
          if (item.status.toUpperCase() === 'PENDING') {
            this.containsPending = true
            return false
          }
          this.salaryIds.push(item.id)
        })
        if (this.containsPending) {
          this.warningDialog = true
        } else {
          this.checkoutDialog = true
        }
      },

      confirmCheckout () {
        this.tableLoading = true
        this.checkoutProgressing = true

        this.$api.payroll().checkout(this.batchId, this.salaryIds)
          .then(res => {
            this.loadEmployees()
            this.$emit('updated')
            this.$snack({ message: 'Salary status succesfully updated' })

            this.salaryIds = []
            this.checkoutDialog = false
            this.checkoutProgressing = false
            this.tableLoading = false
          }).catch(() => {
            this.$snack({ 
              color: 'error',
              message: 'Failed to update salary status', 
            })
          })
      },

      revert () {
        this.revertDialog = true
      },

      confirmRevert () {
        this.tableLoading = true
        this.revertProgressing = true

        this.$api.payroll().revert(this.batchId)
          .then(res => {
            this.loadEmployees()
            this.$emit('updated')
            this.$snack({ message: 'Salary status succesfully reverted' })

            this.revertDialog = false
            this.revertProgressing = false
            this.tableLoading = false
          }).catch(() => {
            this.$snack({ 
              color: 'error',
              message: 'Failed to update salary status', 
            })
          })
      },

      loadEmployees () {
        this.tableLoading = true
        this.detailLoading = true
        
        Promise.all([
          this.$api.companySalaryBatch().show(this.batchId),
          this.$api.payroll().list(this.batchId),
        ])
          .then(([selectedBatch, payrollList]) => {
            this.batchData = selectedBatch.data
            this.employees = _.orderBy(payrollList.data, ['company_employee.employee.person.name'], ['asc'])
            this.selected = []
            this.detailLoading = false
            this.tableLoading = false
          })
      },

      retrieve () {
        this.tableLoading = true
        this.payrollClosing = null
        this.isAllStatusCompleted = false
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            Promise.all([
              this.$api.companySalaryBatch().list(this.company.id),
              this.$api.payrollClosing().list({ salaryMonth: this.salaryMonth, company_uid: this.company.id }),
            ])
              .then(([batches, payrollClosing]) => {
                if (payrollClosing.data) {
                  this.payrollClosing = payrollClosing.data
                }

                if (batches.data.length > 0) {
                  this.batches = this.getCurrentMonthBatches(batches.data)
                  this.salaryBatches = _.orderBy(this.batches, ['created_at', 'name'], ['desc', 'asc'])
                  if (this.salaryBatches && this.salaryBatches.length > 0) {
                    for (let item in this.salaryBatches) {
                      this.isAllStatusCompleted = this.salaryBatches[item].status.toUpperCase() === 'COMPLETED'
                      if (!this.isAllStatusCompleted) {
                        break
                      }
                    }
                  } else {
                    this.salaryBatches = []
                    this.$snack({ color: 'red', message: 'No Record Found' })
                  }
                } else {
                  this.salaryBatches = []
                  this.$snack({ color: 'red', message: 'No Record Found' })
                }
                this.tableLoading = false
              })
          })
      },

      currencyFormatting (item) {
        let value = (Math.round((item / 100) * 100) / 100).toFixed(2)
        return this.thousandSeparator(value)
      },

      thousandSeparator (amount) {
        if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
          return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
          return amount
        }
      },

      updatePage () {
        this.isBatch = false
        this.retrieve()
      },

      beforePayrollClosed () {
        this.payrollClosingDialog = true
      },

      monthEndClosing () {
        this.payrollClosingLoading = true
        this.$api.payrollClosing().create(this.prepareClosingFormData())
          .then(res => {
            this.retrieve()
            this.payrollClosingLoading = false
            this.payrollClosingDialog = false
            this.$snack({ message: 'Payroll ' + this.formatSalaryMonth + ' is closed.' })
          }).catch(() => {
            this.$snack({ 
              color: 'error',
              message: 'Failed to close current month payroll', 
            })
          })
      },

      prepareClosingFormData () {
        return {
          salaryMonth: this.salaryMonth, 
          company_uid: this.company.id,
        }
      },
      
      testing () {
        this.$api.testing().testing()
          .then(res => {
            let blob = new Blob([res.data], { type: 'application/pdf' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.setAttribute('download', 'generated.pdf')
            link.click()
          })
      },
    },
  }
</script>

<style scoped>
.remove-bottom-border {
  border-bottom: 0px !important
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important
}

.align-center {
  text-align:center
}

.selectedRow {
  background-color: rgb(190,216,249)
}

.customised-header{
  font-size:1.0625rem !important
}

.header-border{
  border:1px solid black
}

.header-border-left{
  border-left:1px solid black
}

.header-border-right{
  border-right:1px solid black
}

.header-border-bottom{
  border-bottom:1px solid black !important
}

.disable-pointer-event tr:hover:not(.v-table__expanded__content) {
  background: transparent !important;
}

.employee-listing{
  height:500px;
  overflow-y:scroll;
}

.employee-listing::-webkit-scrollbar {
  width: 3px !important; 
}

/* Track */
.employee-listing::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px #e6e6e6; 
  border-radius: 10px;
}
 
/* Handle */
.employee-listing::-webkit-scrollbar-thumb {
  background: grey; 
  border-radius: 10px;
  height: 2px;
}

/* Handle on hover */
.employee-listing::-webkit-scrollbar-thumb:hover {
  background:  #555; 
}

.summary-header-font-size{
  font-size: 24px;
}
.summary-table-margin{
  margin:20px;
  border-radius:10px;
}

.font-14{
  font-size:14px;
}

.font-18{
  font-size:18px;
}
</style>
